export default "__VITE_ASSET__1k3C$WXv__"